var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertyfikat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#071d49;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M35.89,35.07s-.07,.04-.13,.05l-.33,.06v-.05l-2.41,.42-.4,.29,2.59,3.97,1.2-2.85h3.1l-1.73-2.65c-.56,.39-1.21,.65-1.89,.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M20.39,35.25c-.82-.1-1.56-.4-2.17-.88l-1.72,2.59h3.09l.43,1.07,.77,1.78,2.6-3.93-.36-.28-2.64-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M35.96,31.43v-.06l.17-.13c.08-.13,.12-.29,.14-.44l.54-3.65,2-2.81c.37-.59,.3-1.27,.04-1.63l-2.09-2.85-.05-.39-.58-3.29c-.06-.48-.4-.82-.91-.88l-3.65-.54-2.85-2.05c-.38-.27-1.06-.27-1.46,0l-2.91,2.09-.43,.05-3,.44c-.29,.07-.56,.23-.77,.44-.22,.21-.37,.48-.45,.78l-.06,.13-.44,3.34-.28,.33-1.78,2.31c-.37,.59-.3,1.3-.04,1.67l2.09,2.85,.06,.44,.58,3.38c.02,.12,.06,.26,.14,.39,.08,.13,.19,.25,.32,.34,.13,.08,.28,.13,.44,.15l3.65,.5,.33,.28,2.31,1.78c.59,.37,1.3,.3,1.67,.04l2.86-2.09,.44-.05,3.38-.58c.2-.02,.4-.12,.56-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M28,0C12.54,0,0,12.54,0,28s12.54,28,28,28,28-12.54,28-28S43.46,0,28,0Zm10.7,40.38l-2.8,6.6-6.13-9.25c-1.08,.43-2.34,.42-3.53,0l-6.14,9.26-1.23-2.94-1.57-3.66h-7.16l1.77-2.63,4.53-6.9-.41-2.28-1.66-2.31c-1.11-1.56-1.15-3.68-.1-5.41v-.04l.09-.13,1.62-2.09,.35-2.8,.07-.08c.22-.92,.69-1.75,1.36-2.42s1.5-1.13,2.41-1.36l.03-.03,.16-.04,2.66-.34,2.3-1.61c.82-.59,1.75-.9,2.7-.9h0c.98,.01,1.91,.32,2.7,.9l2.3,1.6,2.61,.35c2.02,.24,3.59,1.8,3.89,3.8,.02,.03,.04,.08,.05,.13l.05,.33h-.03l.46,2.28,1.61,2.31c1.1,1.54,1.14,3.64,.1,5.37v.04l-.09,.13-1.62,2.31-.33,2.5,6.16,9.31h-7.16Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertyfikat);
export default __webpack_public_path__ + "static/media/certyfikat.e9ef4d0dbc339c15a1b4232d1e10495f.svg";
export { ForwardRef as ReactComponent };